import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BASENAME } from "../../../utils/basename";
import { URLASSOLUTO } from "../../../utils/urlassoluto";

const MessaggioProdottoAnchePacchetto = ({ linkSeoPackagePage = null }) => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const currentPage = useSelector((state) => state.currentPage);

  const testoOmaggio = `<i className="far fa-box text-2xl mr-6"></i>
  <span>
    {genericheTranslation.messaggioprodottoanchepacchetto.itemName}
    </span>`;
  const immagineOmaggio = (
    <img
      src={`${BASENAME}/images/banner_pacchetto${currentPage.currentLang}.webp`}
      width="420"
      height="150"
      className="flex-start w-full object-fit cursor-pointer mt-3"
      alt={genericheTranslation.messaggioprodottoanchepacchetto.itemName}
    />
  );
  useEffect(() => {
    console.log("MessaggioProdottoAnchePacchetto");
  }, []);
  return (
    <a
      href={URLASSOLUTO + linkSeoPackagePage}
      className="flex items-center h-full"
    >
      {immagineOmaggio}
    </a>
  );
};

export default MessaggioProdottoAnchePacchetto;
